module.exports = __webpack_public_path__ + "static/media/thoriacImage2@3x.e053446c.png";